import { render, staticRenderFns } from "./BankAccountCreateUpdate.vue?vue&type=template&id=b32c5c40&scoped=true&"
import script from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountCreateUpdate.vue?vue&type=style&index=0&id=b32c5c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32c5c40",
  null
  
)

export default component.exports